import { useEffect, useState } from 'react';
import { configAPI } from '../services/api';
import { adminAPI } from '../services/adminAPI';
import { DEFAULT_LANGUAGES, normalizeLanguageOptions } from '../config/languages';

export const useLanguageOptions = () => {
  const [languages, setLanguages] = useState(DEFAULT_LANGUAGES);
  const [restrictedLanguages, setRestrictedLanguages] = useState([]);
  const [modelAccuracy, setModelAccuracy] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const [langResp, thresholdResp, accuracyResp] = await Promise.all([
          configAPI.getLanguages().catch(() => null),
          adminAPI.getLanguageThresholds().catch(() => null),
          adminAPI.getModelAccuracy().catch(() => null),
        ]);

        if (!cancelled) {
          if (langResp?.data) {
            setLanguages(normalizeLanguageOptions(langResp.data));
          }
          const thresholdData = thresholdResp?.data?.data || thresholdResp?.data;
          setRestrictedLanguages(thresholdData?.restricted || []);
          const accuracyPayload = accuracyResp?.data || {};
          const aggregates =
            accuracyPayload.aggregates ||
            accuracyPayload.data?.aggregates ||
            [];
          setModelAccuracy(Array.isArray(aggregates) ? aggregates : []);
        }
      } catch {
        if (!cancelled) {
          setLanguages(DEFAULT_LANGUAGES);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  const languagesWithStatus = languages.map((lang) => ({
    ...lang,
    restricted: restrictedLanguages.some(
      (r) => r.toLowerCase() === lang.label.toLowerCase()
    ),
    threshold_status: restrictedLanguages.some(
      (r) => r.toLowerCase() === lang.label.toLowerCase()
    )
      ? 'restricted'
      : 'approved',
  }));

  return { languages: languagesWithStatus, restrictedLanguages, loading, modelAccuracy };
};

export default useLanguageOptions;
